angular.module('dpw.directives')
    .component('dpwHeaderLinks', {
        templateUrl: 'dpw-header-links.html',
        controller: ['$scope', 'user', 'userInfoFormatter', '$timeout', '$q', 'api', 'organizationService', 'mixpanelService', 'helpers', 'dpwAccessService', function ($scope, user, userInfoFormatter, $timeout, $q, api, organizationService, mixpanelService, helpers, dpwAccessService) {
            var self = this;
            var timer;

            self.items = [
                {label: 'RINGCENTRAL.COM', href: 'https://www.ringcentral.com', target: '_blank'},
                {label: 'APP GALLERY', href: 'https://www.ringcentral.com/apps/', target: '_blank'},
            ];

            self.shouldShowLogin = function () {
                return !helpers.isLoginPage() && !self.userInfoString;
            };

            self.isShowInfoNavs = false;

            self.showInfoNavs = function () {
                timer && $timeout.cancel(timer);
                self.isShowInfoNavs = true;
            };
            self.hideInfoNavs = function () {
                timer = $timeout(function () {
                    self.isShowInfoNavs = false;
                }, 1000);
            };
            self.toggleDisplay = function () {
                self.isShowInfoNavs = !self.isShowInfoNavs;
            };
            self.clickInfoNav = function () {
                self.isShowInfoNavs = false;
            };

            self.getHref = function (nav) {
                return nav.entryHash ? ('/my-account.html#/' + nav.entryHash) : nav.href;
            };

            self.login = function () {
                api.call(
                    api.threeLeg.getLoginUrl(),
                    function (data) {
                        window.location = _.get(data, 'oAuthUrl');
                    }
                );
            };

            self.logout = function () {
                api.logout().success(function (o) {
                    if (o.status.status !== 'SUCCESS') {
                        RCDPW.modal.create().content(RCDPW.Lang.INTERNAL_ERROR).show();
                    } else {
                        api.threeLogout(function () {
                            mixpanelService.reset();
                            window.location = '/';
                        });
                    }
                });
            };

            self.navs = [
                {
                    icon: 'icon-icon_profile',
                    text: 'User Profile',
                    entryHash: 'my-profile'
                }
            ];

            if (RCDPW.isLogin) {
                user.fetch()
                    .then(function () {
                        var userInfo = user.getUser();
                        self.userInfoString = userInfoFormatter(userInfo);
                    })
                    .then(resolveCredentialsItem)
                    .then(resolveAccountPortalItem);
            }

            $scope.$on('dpwHeader:updateUserInfo', function () {
                if (RCDPW.isLogin) {
                    user.forceFetch().then(function () {
                        self.userInfoString = userInfoFormatter(user.getUser());
                    });
                }
            });

            function resolveCredentialsItem() {
                return $q(function (resolve) {
                    dpwAccessService.currentUserCan(
                        dpwAccessService.UserAction.VIEW_MY_API_CREDENTIALS
                    ).then(function () {
                        self.navs.push({
                            icon: 'icon-credentials',
                            text: 'Credentials',
                            href: '/console/my-credentials'
                        });
                    }).finally(resolve);
                });
            }

            function resolveAccountPortalItem() {
                return $q(function (resolve) {
                    var userInfo = user.getUser();

                    if (userInfo.isFreeTier) {
                        resolve();
                        return;
                    }

                    api.call(api.myAccount.applications.clientInfo(), function (data) {
                        var prodServiceWebUrl = helpers.onlinePortalLinks.prod(data.serviceWebHome);
                        self.navs.push({
                            icon: 'icon-link',
                            text: 'Account portal',
                            href: prodServiceWebUrl,
                            target: '_blank'
                        });
                        resolve();
                    }, function () {
                        resolve();
                    });
                });
            }

        }]
    });

